import { h, Component } from 'preact';
import pure from 'utils/pure';
import Store from 'store/store';
import { accessNested } from 'utils/utils';

 // @pure
export default class Cookies extends Component {


	// constructor() {
	// 	super();
	// 	this.regions = {
	// 		gb: 'uk',
	// 		at: 'at',
	// 		be_fr: 'fr',
	// 		be_nl: 'nl',
	// 		ch: 'ch-de',
	// 		ch_fr: 'ch-fr',
	// 		de: 'at',
	// 		es: 'es',
	// 		fr: 'fr',
	// 		ie: 'ie',
	// 		it: 'it',
	// 		nl: 'nl',
	// 		pt: 'pt',
	// 		se: 'se',
	// 	};
	//
	// 	this.renderOldCookiePopup = this.renderOldCookiePopup.bind(this);
	// }

	// componentWillMount() {
	// 	this.region = this.regions[accessNested(this.props, 'appData.meta.region.slug')];
	// }

	//RENDER METHODS
	//-----------------------------------------------


	renderOldCookiePopup() { }

	render({ appData }) {
		return this.renderOldCookiePopup();
// 		const {
// 			useOldCookiePopup,
// 			disableCookiePopup
// 		} = appData.options;
//
// 		if (disableCookiePopup) return;
//
// 		if (useOldCookiePopup) {
// 			return this.renderOldCookiePopup();
// 		}
// 		if (!this.region) return;
// 		return (
// 			<div>
// 				<script src="http://www.geoplugin.net/javascript.gp" />
// 				<script src={`http://www.upi-digital.com/cookie-consent/js/${this.region}/cookieControl-5.1.min.js`} />
// 				<script dangerouslySetInnerHTML={{__html: `
// cookieControl({
// 	onAccept: function() { },
// 	onReady: function() { },
// 	onCookiesAllowed: function() { },
// 	onCookiesNotAllowed: function() { }
// });
// setTimeout(function() {
// 	var elem = document.getElementById('cctoggle');
// 	if (elem) {
// 		elem.addEventListener('click', function(e) { e.preventDefault(); });
// 	}
// }, 100);
//
// function ccAddAnalytics(cookieEvent) {
// 	if (typeof ga !== 'function') return;
// 	ga('global.send', 'event', 'Cookies', 'Cookie Link Clicked', cookieEvent);
// 	ga('local.send', 'event', 'Cookies', 'Cookie Link Clicked', cookieEvent);
// }
// 				`}} />
// 			</div>
		// );
	}
}
